<template>
  <div class="col-xl-12 col-lg-12 col-sm-12 col-md-12 mt-3">
    <generalForm typeForm="address" :variableData="variableDataComponent">
    </generalForm>
  </div>
</template>
<script>
import generalForm from '@/src/components/variables/general-form'

export default {
  name: 'addressComponent',
  components: {
    generalForm,
  },
  props: {
    variableDataComponent: {
      type: Object,
      required: false,
      default: () => {
        return {}
      },
    },
  },
}
</script>
